class QuantitySelector extends HTMLElement {
  value; entity;

  constructor() {
    super();
    this.value = Number(this.innerText);
    this.entity = this.dataset.entity;
  }
  
  add = (num) => {
    this.set(this.value + num);
  }

  remove = (num) => {
    this.set(this.value - num);
  }

  set = (num) => {
    const min = Number(this.dataset.min) || 0;
    const max = Number(this.dataset.max);
    // Valida che la quantità rientri nei limiti min/max (se max non è definito non applica il limite superiore)
    if((max != NaN && num <= max && num >= min) || (max == NaN && num >= min)) {
      this.value = num;
      this.dispatchEvent(new CustomEvent(Utils.E_QUANTITY_INPUT_CHANGED, {detail: {value: this.value}}));
      this.show();
    }
  }

  show = () => {
    this.innerText = this.value;
  }
}
if (!window.customElements.get("quantity-selector")) {
  window.customElements.define("quantity-selector", QuantitySelector);
}

class QuantitySelectorButton extends HTMLElement {
  quantitySelector;

  constructor() {
    super();

    this.quantitySelector = document.querySelector(this.dataset.selector);

    if(this.quantitySelector != undefined) {
      this.addEventListener('click', () => this.handleClick());
      // Operabilità da tastiera: Invio/Spazio attivano il pulsante (role="button")
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleClick();
        }
      });
    }
  }

  handleClick = () => {
    const add = Number(this.dataset.add);
    const remove = Number(this.dataset.remove);
    if(add > 0){
      this.quantitySelector.add(add);
    }
    if(remove > 0){
      this.quantitySelector.remove(remove);
    }
  }
}
if (!window.customElements.get("quantity-selector-button")) {
  window.customElements.define("quantity-selector-button", QuantitySelectorButton);
}

class MainCart extends HTMLElement {
  quantitySelectors; removers;
  static selectors = {
    loader: 'theme-loader[data-global]'
  }

  constructor() {
    super();
    this.init();

    window.addEventListener(Utils.E_CART_ADDED, (e) => this.showNotification(e.detail));
  }

  init = () => {
    this.quantitySelectors = document.querySelectorAll('quantity-selector');
    this.removers = document.querySelectorAll('[data-cart-remove]');
    this.loader = document.querySelector(MainCart.selectors.loader);

    this.quantitySelectors.forEach((qs) => {
      qs.addEventListener(Utils.E_QUANTITY_INPUT_CHANGED, () => this.changeQuantity(qs));
    });
    this.removers.forEach((r) => {
      r.addEventListener('click', (e) => this.removeItem(e, r));
    });
  }

  showNotification = (added) => {
    this.lastAdded = added;
    this.updateCart(() => {
      const notification = document.querySelector('#cart-popup');
      if(notification != undefined){
        notification.show();
      }
    });
  }

  selectNotificationItem = () => {
    // Nel toast mostra la riga della variante appena aggiunta (non il prodotto della pagina, es. un look).
    // cart/add.js restituisce la line item, oppure { items: [...] } se il form invia items[]
    const added = this.lastAdded;
    this.lastAdded = null;
    const item = added && added.items ? added.items[0] : added;
    if(!item || !item.variant_id) return;
    const blocks = this.querySelectorAll('[data-cart-popup-item]');
    const match = Array.from(blocks).find((b) => b.dataset.cartPopupItem == item.variant_id);
    if(match == undefined) return;
    blocks.forEach((b) => { b.hidden = b !== match; });
  }

  hideNotification = () => {
    const notification = document.querySelector('#cart-popup');
    if(notification != undefined){
      notification.hide();
    }
  }

  changeQuantity = (qs) => {
    // Sincronizza il carrello con le modifiche di quantità tramite l'API Shopify
    this.openLoader();
    const data = {
      id: qs.entity,
      quantity: qs.value
    };
    const url = window.Shopify.routes.root + 'cart/change.js';
    axios.post(url, data)
      .then((response) => {
        // Ricarica il carrello completo per assicurare la sincronizzazione
        this.updateCart();
      })
      .catch((error) => {
        Utils.errorHanlder(error, (error.response.data.description || error.message));
      });
  }

  removeItem = (e, item) => {
    this.openLoader();
    e.preventDefault(); 
    axios.get(item.href).then((response) => {
      window.dispatchEvent(new CustomEvent(Utils.E_CART_REMOVED, { detail: JSON.parse(item.dataset.cartRemove) }));
      this.updateCart();
    }).catch((error) => {
      Utils.errorHanlder(error);
    });
  }

  updateCart = (callback) => {
    // Ricarica completamente il carrello dal server per sincronizzare lo stato dopo modifiche
    // Reinizializza tutti gli event listener dopo aver aggiornato il DOM
    axios.get(location.href)
      .then((response) => {        
        this.hideNotification();
        const doc = Utils.getDocument(response.data);
        this.innerHTML = doc.querySelector('main-cart').innerHTML;
        this.init();
        this.selectNotificationItem();
        const notification = document.querySelector('#cart-popup');
        if(notification != undefined){
          notification.show();
        }
        if(typeof callback === 'function'){
          callback();
        }
      })
      .catch((error) => {
        Utils.errorHanlder(error);
      })
      .finally(() => {
        this.closeLoader();
      });
  }

  openLoader = () => {
    if(this.loader != undefined){
      this.loader.show();
    }
  }

  closeLoader = () => {
    if(this.loader != undefined){
      this.loader.hide();
    }
  }
}
if (!window.customElements.get("main-cart")) {
  window.customElements.define("main-cart", MainCart);
}

class VariantAdd extends HTMLElement {

  connectedCallback() {
    this.addEventListener('click', (e) => this.add(e));
  } 

  add = () => {
    const data = new FormData();
    data.append('id', this.dataset.variant);
    data.append('quantity', this.dataset.quantity || 1);
    Utils.addTocart({
      data: data
    });
  }
}
if (!window.customElements.get("variant-add")) {
  window.customElements.define("variant-add", VariantAdd);
}